import type { Row } from "./api";

// Presentation routing only. The server remains authoritative for every action.
export function requiresAuthenticator(session: Row | null) {
  return Boolean(
    session?.user &&
    session.registration?.mfaRequired === true &&
    session.user.mfaEnabled !== true,
  );
}

export function isAccountSecurityRoute(path: string) {
  return [
    "/auth/mfa",
    "/auth/sessions",
    "/auth/devices",
    "/auth/password-reset",
  ].includes(path);
}

export function bootstrapFailureTitle(code: string) {
  return code.startsWith("LICENSE_")
    ? "Firm access needs attention."
    : "Connection needs attention.";
}
